module.exports = __webpack_public_path__ + "img/BBVA.c7814590.png";